import React from 'react';
import { Star } from 'lucide-react';
export function Reviews() {
  const reviews = [{
    text: 'Yo decoraba gratis para todo el grupo de amigas. Con este sistema armé mi primer presupuesto real y cobré mi primer evento. Todavía no lo puedo creer.',
    author: 'Maite R.',
    location: 'Buenos Aires'
  }, {
    text: 'Los prompts de IA para armar el render antes de comprar los globos me cambiaron la cabeza. Ya no compro de más ni me quedo corta.',
    author: 'Vale D.',
    location: 'Córdoba'
  }, {
    text: 'Hice el mesversario de mi sobrina siguiendo el Tomo 2 y quedó tan lindo que ya tengo 3 eventos más agendados. De hobby a changa real.',
    author: 'Ceci M.',
    location: 'Rosario'
  }];
  return <section className="py-12 px-5 bg-white" data-id="element-225">
      <div className="max-w-md mx-auto" data-id="element-226">
        <h2 className="text-2xl font-bold text-wine text-center mb-8" data-id="element-227">
          Lo que dicen las que ya lo tienen
        </h2>

        <div className="flex flex-col gap-4" data-id="element-228">
          {reviews.map((review, idx) => <div key={idx} className="bg-cream/30 border border-cream rounded-2xl p-5 shadow-sm" data-id="element-229">
              <div className="flex gap-1 mb-3" data-id="element-230">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 text-gold fill-gold" data-id="element-231" />)}
              </div>
              <p className="text-[15px] text-dark/90 italic mb-4 leading-relaxed" data-id="element-232">
                "{review.text}"
              </p>
              <div className="text-sm font-bold text-wine" data-id="element-233">
                — {review.author}{' '}
                <span className="text-dark/50 font-normal" data-id="element-234">
                  · {review.location}
                </span>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}